import { addModal, removeModal } from "slices/app/modalsSlice";
import { removeErrorMessage } from "slices/app/errorSlice";
import { clearJobQueue, removeFromJobQueue } from "slices/app/appSlice";

export const showModal = (modalType, modalProps) => (dispatch) => {
  dispatch(addModal({ modalType, modalProps }));
};

export const hideModal = (modalType) => (dispatch) => {
  dispatch(removeModal({ modalType }));
  dispatch(removeErrorMessage());
  dispatch(removeFromJobQueue("genericJob"));
};
